import { render, staticRenderFns } from "./ParametrizacoesManage.vue?vue&type=template&id=2357d89c&scoped=true"
import script from "./ParametrizacoesManage.vue?vue&type=script&lang=js"
export * from "./ParametrizacoesManage.vue?vue&type=script&lang=js"
import style0 from "./ParametrizacoesManage.vue?vue&type=style&index=0&id=2357d89c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357d89c",
  null
  
)

export default component.exports